export enum ComorbiditiesChoice {
    ja = 'Ja, namelijk..',
    nee = 'Nee, er zijn geen relevante comorbiditeiten aanwezig',
}
